import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../../constants/componentStaticData';
import { SimpleCarousal } from '../../Atoms/Carousel';
import { If } from '../../Atoms/Conditionals';
import { Heading, HeadingType } from '../../Typography';
import { useViewport } from '../../hooks';
import { CardsGuides } from './guides_card';

export type TGuideCard = {
  label: string;
  description: string;
  link: string;
};
interface GuidesAndLinkProps {
  heading: string;
  cards: TGuideCard[];
}

const GuidesAndUsefullLink = ({
  heading,
  cards,
}: GuidesAndLinkProps): JSX.Element => {
  const [windowWidth, setWidth] = useState(1024);
  const { width } = useViewport();
  const isMobile = windowWidth && windowWidth < MOBILE_BREAKPOINT;

  useEffect(() => {
    const { innerWidth: widthSize } = window;
    setWidth(widthSize);
  }, [width]);

  const renderCards = (cardsData: TGuideCard[]) => {
    return cardsData.map((item) => (
      <div className="w-1/4 md:w-1/2 sm:w-full" key={item.label}>
        <CardsGuides cardData={item} />
      </div>
    ));
  };

  return (
    <>
      <If condition={!!heading}>
        <Heading
          content={heading}
          variant={HeadingType.h2}
          className="text-s-48 mb-9 sm:text-s-32 sm:mb-7"
        />
      </If>

      <div>
        {isMobile ? (
          <SimpleCarousal
            slidesToShow={1}
            autoplay={true}
            infinite={true}
            slidesToScroll={1}
            arrows={false}
            dots={true}
            dotsClass="slick-dash"
          >
            {renderCards(cards)}
          </SimpleCarousal>
        ) : (
          <div className="flex flex-wrap -mx-3">{renderCards(cards)}</div>
        )}
      </div>
    </>
  );
};

export { GuidesAndUsefullLink };
